import { useCustomOverrides } from 'core/dev-toolbox/features/custom-overrides/custom-overrides-state';

const OVERRIDES = [
  'mockLlmAnalytics',
  'mockOpsPilotAcknowledgement',
  'mockTpuCostData',
  'mockDboDatabaseInstances',
  'mockCustomDashboards',
  'mockRestrictionSilences',
] as const;

type OverrideName = (typeof OVERRIDES)[number];

/** Register all mock-middleware overrides in the Dev Toolbox Custom Overrides panel. */
export const registerOverrides = () => {
  const store = useCustomOverrides.getState();
  for (const name of OVERRIDES) {
    store._registerField({ name, type: 'boolean' });
  }
  store._registerField({
    name: 'mockDboScenario',
    type: 'dropdown',
    options: ['manual', 'aws', 'gcp', 'empty'],
  });
};

/** Non-reactive getter for use in middleware (outside React). */
export const getOverride = (name: OverrideName): boolean =>
  useCustomOverrides.getState().overrides[name] === true;

/** Non-reactive getter for string-valued overrides (e.g. the DBO mock scenario). */
export const getOverrideValue = (name: string): string | undefined => {
  const value = useCustomOverrides.getState().overrides[name];
  return typeof value === 'string' ? value : undefined;
};
